export default "__VITE_ASSET__e6525a77__"